import { useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { loadScript } from "../../utils/script";

// Google AdSense slot. Renders nothing until VITE_ADSENSE_CLIENT is set in
// .env (ca-pub-XXXXXXXXXXXXXXXX). Each placement passes its own slot id
// created in the AdSense dashboard.
const client = import.meta.env.VITE_ADSENSE_CLIENT;
let scriptRequested = false;

export const AdSlot = ({ slot, format = "auto" }) => {
  const insRef = useRef(null);

  useEffect(() => {
    if (!client || !slot) return;

    const pushAd = () => {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch {}
    };

    if (!scriptRequested) {
      scriptRequested = true;
      loadScript(
        `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`,
        pushAd,
      );
    } else {
      pushAd();
    }
  }, [slot]);

  if (!client || !slot) return null;

  return (
    <ins
      ref={insRef}
      className="adsbygoogle"
      style={{ display: "block", minHeight: 90, margin: "16px 0" }}
      data-ad-client={client}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive="true"
    />
  );
};

AdSlot.propTypes = {
  slot: PropTypes.string,
  format: PropTypes.string,
};
